import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import { StatisticsBoard } from "components/StatisticsBoard";

import { IWithballData } from "apis";
import { ICoordinate } from "types";

interface IStyleProps {
  position: ICoordinate;
}

interface IHoverLayerProps extends IStyleProps {
  data: IWithballData[];
}

const WIDTH = 400;

const useStyles = makeStyles(() => ({
  hoverLayer: ({ position }: IStyleProps) => ({
    width: WIDTH,
    position: "absolute",
    top: position.y - 280,
    left: position.x,
    zIndex: 999,
  }),
}));

export const HoverLayer = ({ position, data }: IHoverLayerProps) => {
  const classes = useStyles({ position });
  return (
    <div className={classes.hoverLayer}>
      <StatisticsBoard data={data} />
    </div>
  );
};
